export default "__VITE_ASSET__CJZD0n5W__"